module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/wearing/wearing-11-5f1492d7854133a9c6c204035dfb5398.jpg";